var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinRepostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7376 8.0476L19.623 7.93573L18.8769 7.94502L18.1309 7.9543L18.0073 8.06913L17.8798 8.18401L17.9221 12.5237L17.9683 16.8633L13.5155 16.9187L9.06663 16.974L9.04417 16.111L9.02171 15.2479L8.8914 15.1362C8.70578 14.9745 8.49886 14.9848 8.31742 15.159C8.24794 15.2263 7.71674 15.8618 7.14736 16.5682C6.14693 17.7956 6.1047 17.8547 6.10664 18.0109C6.10907 18.2062 6.03755 18.1095 7.37349 19.6711C7.90076 20.2896 8.38799 20.8304 8.45503 20.8804C8.59691 20.9802 8.72199 20.9864 8.87721 20.9025C9.09068 20.7904 9.10899 20.6925 9.09771 19.7864L9.08751 18.9661L14.1574 18.903C18.9774 18.843 19.2312 18.836 19.3788 18.7638C19.6118 18.6555 19.77 18.5011 19.8766 18.2771L19.9757 18.0728L19.914 13.1161L19.8523 8.15946L19.7376 8.0476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8373 3.84026C17.8291 3.80911 17.3016 3.175 16.6634 2.42897C15.6447 1.24625 15.4863 1.07633 15.3609 1.04664C15.263 1.02441 15.181 1.02934 15.0993 1.06161C14.8779 1.15812 14.8668 1.21295 14.8668 2.15053L14.8657 3.00217L9.26087 3.09144L3.65608 3.18072L3.47386 3.29237C3.37303 3.35223 3.24545 3.45929 3.19555 3.53023C2.96889 3.83776 2.97642 3.5017 3.0435 8.89191L3.10508 13.8407L3.21976 13.9526L3.33444 14.0645L4.08048 14.0552L4.82652 14.0459L4.9501 13.9311L5.07758 13.8162L5.0353 9.47655L4.98912 5.13694L9.94967 5.07521L14.9102 5.01349L14.921 5.8767L14.9317 6.73992L15.0464 6.85178C15.1412 6.94045 15.1962 6.96321 15.3329 6.9615C15.4345 6.96024 15.5318 6.93168 15.582 6.88809C15.7405 6.75329 17.818 4.17255 17.8402 4.07852C17.8663 3.97272 17.8658 3.93757 17.8373 3.84026Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20.8748 0.876465) rotate(89.2871)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinRepostIcon);
export default __webpack_public_path__ + "static/media/linkedin-repost-icon.f35690607936310a7335af497bf5348d.svg";
export { ForwardRef as ReactComponent };